import { DateTime } from 'luxon';

import { Campaign } from 'apis/restaurant-api/merchant-admin/campaigns/types';
import { convertMonetaryIntToDecimal } from 'common/utils/currencyDecimals';

import { API_UNLIMITED_TOTAL_BUDGET_SUM, UNLIMITED_TOTAL_BUDGET_SUM } from '../../components/budget-section/constants';
import { CommonCampaignFormValues } from '../../types';

export const transformCampaignApiToCommonFormFields = (
  campaign: Campaign,
  timezone: string,
): CommonCampaignFormValues => ({
  campaignId: campaign.id,
  totalBudgetSum:
    campaign.total_budget_sum === API_UNLIMITED_TOTAL_BUDGET_SUM
      ? UNLIMITED_TOTAL_BUDGET_SUM
      : convertMonetaryIntToDecimal(Number(campaign.total_budget_sum), campaign.currency),
  minBasketSize: campaign.min_basket_size,
  firstPurchaseOnly: campaign.first_purchase_only ?? false,
  usageType:
    campaign.first_purchase_only === false ? (campaign.per_user_usage_limit ? 'limited' : 'indefinitely') : undefined, // usage type is only applicable when campaign is available for all users
  perUserUsageLimit: campaign.per_user_usage_limit || undefined,
  startDate: DateTime.fromISO(campaign.start_date).setZone(timezone).toISO(),
  endDate: DateTime.fromISO(campaign.end_date).setZone(timezone).toISO(),
  weeklySchedule: campaign.weekly_schedule,
  agreementTermsAndConditions: true,
  venueIds: campaign.venue_ids,
});
